module.exports = __webpack_public_path__ + "img/dadd88b.png";